import {VisitorUpdateApp} from "../Functionality/VisitorUpdateApp";
import StepperTabs from "../../../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../../../components/StepperTabs/StepTab";
import VisitorOverview from "./VisitorOverview";
import VisitorHistoryTable from "./VisitorHistoryTable";
import HeadTittle from "../../../../../components/HeadTittle";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {EditIcon} from "../../../../../components/buttons/IconButtons";
import React from "react";
import {TABS_VISITOR_UPDATE} from "../Model/Model";
import IdentityVerification from "./IdentityVerification";
import {CustomSwitch} from "../../../../../components/CustomSwitch";
import UpdateIdentityValidationModal from "../Modal/UpdateIdentityValidationModal";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";
import ConfirmModal from "../../Invitation/Modal/ConfirmModal";
import {permissionObj} from "../../../../../Helpers/permission";
import RequestAccessHistoryTable from "./RequestAccessHistoryTable";
import {CommonIdentityVerificationApp} from "../../Request/Functionality/CommonIdentityVerificationApp";
import {useLocation} from "react-router-dom";
import {USER_TYPE_MODEL} from "../../../../../enums/userTypeEnum";


/**
 * @Email: kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer
 * @component

 * @returns {JSX.Element} The rendered modal component.
 */

const VisitorUpdate = () => {
    const location = useLocation();
    let { id: userId, disabled : disabledState  } = location?.state;
    const userTypeId = USER_TYPE_MODEL.VISITOR;

    const {
        item,
        setItem,
        disabled,
        identityDocuments,
        identityValidationType,
        identityValidationStatus,
        setModified,
        modified
    } = CommonIdentityVerificationApp({
        userId,
        userTypeId,
        disabledState
    });

    const {
        t,
        DEV,
        permission,
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        handleChange,
        emptyFields,
        isValidPhoneNumber,
        isValidDocumentId,
        handleUpdate,
        identityValidationModals,
        setShowApproveModal,
        setShowDeniedModal,
        showActiveInactiveModal,
        setShowActiveInactiveModal,
        statusId,
        handleUpdateStatus,
        handleOnBack,
        validatePhone
    } = VisitorUpdateApp({
        setModified,
        item,
        setItem
    });

    return (
        <>
            <HeadTittle name={ disabled ? 'details' : 'update'} onBack={handleOnBack}>
                {(DEV || permission.includes(permissionObj?.WEB_VISITOR_UPDATE)) &&
                    <div className={"switch"}>
                        <CustomSwitch
                            id="cb_vu_required"
                            checked={statusId === STATUS_MODEL.ACTIVE}
                            onChange={() => setShowActiveInactiveModal(true)}
                            trans={t('active')}
                            name="statusId"
                        />
                    </div>
                }

                { !disabled && (DEV || permission.includes(permissionObj?.WEB_VISITOR_UPDATE)) &&
                activeStep === TABS_VISITOR_UPDATE.OVERVIEW.INDEX &&
                    <>
                        <ButtonAction
                            id='btn_vu_update'
                            name='update'
                            Icon={EditIcon}
                            className='btn-icon-edit'
                            onClick={handleUpdate}
                        />
                    </>
                }
            </HeadTittle>
            <StepperTabs onlyTab={true}
                         disabled={false}
                         steps={steps}
                         activeStep={activeStep}
                         isStepOptional={() => { }} setActiveStep={setActiveStep}
                         handleStepChange={handleStepChange}
            >
                <StepTab index={TABS_VISITOR_UPDATE.OVERVIEW.INDEX} activeStep={activeStep}  normalHeight={true}>
                    {activeStep === TABS_VISITOR_UPDATE.OVERVIEW.INDEX && (
                        <VisitorOverview
                            item={item}
                            disabled={disabled}
                            handleChange={handleChange}
                            emptyFields={emptyFields}
                            isValidPhoneNumber={isValidPhoneNumber}
                            validatePhone={validatePhone}
                            isValidDocumentId={isValidDocumentId}
                        />
                    )}
                </StepTab>
                <StepTab index={TABS_VISITOR_UPDATE.IDENTITY_VERIFICATION.INDEX} activeStep={activeStep}  normalHeight={true}>
                    {identityDocuments && activeStep === TABS_VISITOR_UPDATE.IDENTITY_VERIFICATION.INDEX && (
                        <IdentityVerification
                            item={item}
                            setShowApproveModal={setShowApproveModal}
                            setShowDeniedModal={setShowDeniedModal}
                            disabled={disabled}
                            identityDocuments={identityDocuments}
                            identityValidationType={identityValidationType}
                            identityValidationStatus={identityValidationStatus}
                            userTypeId={userTypeId}
                        />
                    )}
                </StepTab>
                <StepTab index={TABS_VISITOR_UPDATE.INVITATION_HISTORY.INDEX} activeStep={activeStep}  normalHeight={true}>
                    {activeStep === TABS_VISITOR_UPDATE.INVITATION_HISTORY.INDEX && (
                        <VisitorHistoryTable
                            item={item}
                            disabled={disabled}
                            location={location}
                        />
                    )}
                </StepTab>
                <StepTab index={TABS_VISITOR_UPDATE.REQUEST_ACCESS.INDEX} activeStep={activeStep}  normalHeight={true}>
                    {activeStep === TABS_VISITOR_UPDATE.REQUEST_ACCESS.INDEX && (
                        <RequestAccessHistoryTable
                            item={item}
                            disabled={disabled}
                        />
                    )}
                </StepTab>
            </StepperTabs>
            {identityValidationModals.map((props) => {
                const { show, setter} = props
                    return (
                        <>
                            <UpdateIdentityValidationModal
                                show={show}
                                onHide={() => setter(false)}
                                setModified={setModified}
                                modified={modified}
                                userId={userId}
                                {...props}
                            />
                        </>
                    )
                }
            )}

            <ConfirmModal
                show={showActiveInactiveModal}
                onHide={() => setShowActiveInactiveModal(false)}
                onClickFn={() => {
                    handleUpdateStatus();
                    setShowActiveInactiveModal(false);
                }}
                title_modal={parseInt(item.statusId) === STATUS_MODEL.ACTIVE ? 'deactivate_visitor':
                        'activate_visitor'}
                description={parseInt(item.statusId) === STATUS_MODEL.ACTIVE ? t("are_you_sure_you_want_to_deactivate_the_visitor"):
                        t("are_you_sure_you_want_to_activate_the_visitor")}
            />
        </>
    );
};

export default VisitorUpdate;
